import { Box, Flex, Image } from "@chakra-ui/react";
import DeleteIcon from "./assets/delete.png";

const list = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
  { label: "4", value: "4" },
  { label: "5", value: "5" },
  { label: "6", value: "6" },
  { label: "7", value: "7" },
  { label: "8", value: "8" },
  { label: "9", value: "9" },
  { label: ".", value: "." },
  { label: "0", value: "0" },
];

const Keyboard = ({
  value,
  onKeyboardClick,
}: {
  value: string;
  onKeyboardClick: (value: string) => void;
}) => {
  const handleKeyboardClick = (newValue: string) => {
    if (value.includes(".") && newValue.endsWith(".")) return;

    if (newValue.includes(".")) {
      const decimalPart = newValue.split(".")[1];
      if (decimalPart.length > 2) return;
    }

    if (newValue === "0" || newValue === "00") {
      newValue = "0";
    } else if (newValue.startsWith("0") && !newValue.includes(".")) {
      newValue = newValue.slice(1);
    }

    onKeyboardClick(newValue);
  };

  const handleDeleteClick = () => {
    if (value === "0" || value === "00") return;

    const newValue = value.slice(0, value.length - 1) || "0";
    onKeyboardClick(newValue);
  };

  return (
    <Flex
      sx={{
        background: "#FEAA51",
        width: "100%",
        marginTop: "auto",
        position: "absolute",
        bottom: 0,
        left: 0,
      }}
    >
      <Flex
        sx={{
          width: "300px",
          flexWrap: "wrap",
          margin: "0 auto",
        }}
      >
        {list.map((item) => (
          <Flex
            onClick={() => handleKeyboardClick(value + item.value)}
            sx={{
              width: "100px",
              height: "60px",
              color: "#A44A22",
              fontSize: "32px",
              fontWeight: 700,
            }}
            align={"center"}
            justify={"center"}
            key={item.value}
          >
            {item.label}
          </Flex>
        ))}
        <Flex
          sx={{
            width: "100px",
            height: "60px",
            color: "#A44A22",
            fontSize: "32px",
            fontWeight: 700,
          }}
          onClick={handleDeleteClick}
          align={"center"}
          justify={"center"}
        >
          <Image src={DeleteIcon} sx={{ width: "24px" }} />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Keyboard;
